import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
	namespaced: true,
	state: {
		lstEt3: [],
		et3: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 100,
		search: "",
		hasNext: false,
		lstEt3Selected: [],
		lstEt3status: []
	},
	getters: {
		
	},
	mutations: {
		set(state, et3){
			state.et3 = et3
			if (et3)
				state.update = true
		},
		initForm(state){
			state.insert = false
			state.update = false
			state.et3 = null
			state.lstEt3Selected = []
			state.lstEt3status = [ 0,1,2,3,4,5,6,7,8 ]
		},
		setParamsDataTable(state, payload){
			state.lstEt3 = payload.items
			const filterSelected = et3 => et3.selected
			state.lstEt3Selected = payload.items.filter(filterSelected).map(et3 => { return et3.et3etiquet})
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
	},
	actions: {
		initForm(store){
			store.commit("initForm")
		},
		async find(store, et3etiquet){
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios.get(`/Transporter/PostageTag/Find/${et3etiquet}`)
			.then(response => {
				let et3 = Utils.ValidateAxiosResponse(response.data);
				store.commit("set", et3)
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
			});
			store.state.loading = false
		},
		save(store, dontRoute){
			if (store.state.et3.et3etiquet){
				store.dispatch("update", dontRoute)
				return
			}
			store.dispatch("insert")
		},
		async insert(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.post("/Transporter/PostageTag/Insert", store.state.et3 )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/etiquetas-de-postagem")
				store.state.et3 = null
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async update(store, dontRoute){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.put("/Transporter/PostageTag/Update", store.state.et3 )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				if (!dontRoute){
					router.push("/oryxpdv/etiquetas-de-postagem")
				}
				store.dispatch("find", store.state.et3.et3etiquet)

				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async delete(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
			await this._vm.$axios.delete(`/Transporter/PostageTag/Delete/${store.state.et3.et3etiquet}`)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/etiquetas-de-postagem")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async findList(store){
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios.get("/Transporter/PostageTag/FindList")
			.then(response => {
				let lstEt3 = Utils.ValidateAxiosResponse(response.data);
				store.state.lstEt3 = lstEt3
				store.state.hasNext = lstEt3.length > store.state.itemsPerPage
			}).catch(error => {
				store.state.lstEt3 = []
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			})
			store.state.loading = false
		},
		async search(store, { limit = 20, page = 1}){
			store.state.loading = true
			if (store.state.lstEt3status.length == 0)
				store.state.lstEt3status = [ 0,1,2,3,4,5,6,7,8 ]

			let lstEt3status = ""
			for (const et3status of store.state.lstEt3status) {
				lstEt3status += `&et3status=${et3status}` 
			}

			let payload = await this._vm.$axios.get(`/Transporter/PostageTag/Search?search=${store.state.search}&limit=${limit}&page=${page}${lstEt3status}`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				for (const item of payload.items) {
					item.selected = true
				}
				store.commit("setParamsDataTable", payload)
				return true
			})
			.catch((error) => {
				store.state.lstEt3 = []
				store.state.search = ""
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
		async updateStatus(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Consultando etiquetas", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.put("/Transporter/PostageTag/UpdateStatus", store.state.lstEt3Selected )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
		async sendToCart(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Enviando etiquetas", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.post("/Transporter/PostageTag/SendToCart", store.state.lstEt3Selected )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
		async generate(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Gerando etiquetas", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.post("/Transporter/PostageTag/Generate", store.state.lstEt3Selected )
			.then(response => {
				let lstRelatsPath = Utils.ValidateAxiosResponse(response.data);
				if (!!lstRelatsPath && lstRelatsPath.length > 0){
					for (const relatPath of lstRelatsPath) {
						window.open(relatPath)
					}
				}
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
		async print(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Imprimindo etiquetas", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.post("/Transporter/PostageTag/Print", store.state.lstEt3Selected )
			.then(response => {
				let lstRelatsPath = Utils.ValidateAxiosResponse(response.data);
				if (!!lstRelatsPath && lstRelatsPath.length > 0){
					for (const relatPath of lstRelatsPath) {
						window.open(relatPath)
					}
				}
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
		async cancel(store, reason){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Cancelando a etiqueta", indeterminate: true }, {root: true})
			await this._vm.$axios.put(`/Transporter/PostageTag/CancelTag/${store.state.et3.et3etiquet}?description=${reason}` )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				store.dispatch("find", store.state.et3.et3etiquet)
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
				text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async findByOrder(store, et3pedido){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Consultando etiquetas de postagem", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.get(`/Transporter/PostageTag/FindByOrder/${et3pedido}`)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return []
			});
			
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})

			return payload
		},
		async sendNotification(store, et3etiquet){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Enviando notificação", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.put("/Transporter/PostageTag/SendNotification/" + et3etiquet )
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);

				if (!payload)
					throw new Error("Não foi possível enviar a notificação.")

				store.dispatch("parameters/openDialog", {
					titleText: "Sucesso",
					titleColor: "green",
					text: "Notificação enviada com sucesso!"
				}, { root: true })
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
	}
}